import React from 'react';
import { formatTime } from '../utils/timeFormatter';
import { Maximize2 } from 'lucide-react';
import { useFullscreen } from '../contexts/FullscreenContext';

export default function ClockDisplay({ currentTime, showFullscreenButton = true }) {
  const { hours, minutes, seconds, dateString } = formatTime(currentTime);
  const { isFullscreen, toggleFullscreen } = useFullscreen();

  return (
    <>
      {/* 普通模式显示 */}
      {!isFullscreen && (
        <div className="bg-cyan-600/40 backdrop-blur-md rounded-3xl p-4 sm:p-6 md:p-8 mb-8 border border-cyan-400/30 shadow-2xl relative max-w-4xl mx-auto">
          {/* 全屏按钮 - 根据showFullscreenButton参数控制显示 */}
          {showFullscreenButton && (
            <button
              onClick={toggleFullscreen}
              className="hidden md:block absolute top-4 right-4 p-2 bg-white/20 hover:bg-white/30 rounded-lg transition-colors z-10"
            >
              <Maximize2 className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
            </button>
          )}

          <div className="flex justify-center items-center gap-2 sm:gap-3 md:gap-4 mb-4 sm:mb-6">
            <TimeDigit value={hours} isFullscreen={false} />
            <div className="text-4xl sm:text-5xl md:text-6xl font-bold text-white">:</div>
            <TimeDigit value={minutes} isFullscreen={false} />
            <div className="text-4xl sm:text-5xl md:text-6xl font-bold text-white">:</div>
            <TimeDigit value={seconds} isFullscreen={false} />
          </div>

          <div className="text-center text-white text-lg sm:text-xl mb-4 sm:mb-8">
            Today: {dateString}
          </div>
        </div>
      )}

      {/* 全屏模式显示 */}
      {isFullscreen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden p-4">
          {/* 完整的时钟区块 */}
          <div className="bg-cyan-600/40 backdrop-blur-md rounded-3xl p-4 sm:p-6 md:p-8 lg:p-12 border border-cyan-400/30 shadow-2xl relative max-w-6xl mx-auto">
            <div className="flex justify-center items-center gap-2 sm:gap-3 md:gap-4 lg:gap-6 mb-4 sm:mb-6 md:mb-8">
              <TimeDigit value={hours} isFullscreen={true} />
              <div className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-bold text-white">:</div>
              <TimeDigit value={minutes} isFullscreen={true} />
              <div className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-bold text-white">:</div>
              <TimeDigit value={seconds} isFullscreen={true} />
            </div>

            <div className="text-center text-white text-lg sm:text-xl md:text-2xl lg:text-3xl mb-4 sm:mb-8">
              Today: {dateString}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function TimeDigit({ value, isFullscreen }) {
  return (
    <div className={`bg-gradient-to-b from-cyan-500/80 to-cyan-600/80 rounded-2xl shadow-xl border-2 border-cyan-400/50 ${
      isFullscreen 
        ? 'p-2 xs:p-3 sm:p-6 md:p-8 lg:p-12' 
        : 'p-3 sm:p-4 md:p-6'
    }`}>
      <div className={`font-bold text-white font-mono tracking-wider ${
        isFullscreen 
          ? 'text-2xl xs:text-3xl sm:text-5xl md:text-7xl lg:text-9xl' 
          : 'text-3xl sm:text-5xl md:text-8xl'
      }`}>
        {value}
      </div>
    </div>
  );
}